import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { mediaPhone } from '../styles/breakpoints';

import Image from './stacheldraht_gr.png';
import Image2x from './stacheldraht_gr@2x.png';
import ImageSmall from './stacheldraht-kl.png';
import ImageSmall2x from './stacheldraht-kl@2x.png';

const IMAGE = {
  big: {
    width: 1182,
    height: 89,
    phoneScale: 0.5,
    '1x': Image,
    '2x': Image2x,
  },
  small: {
    width: 491,
    height: 130,
    phoneScale: 0.6,
    '1x': ImageSmall,
    '2x': ImageSmall2x,
  },
};

const getImage = (small, prop) => IMAGE[small ? 'small' : 'big'][prop];

const Container = styled.div`
  height: ${({ small }) => getImage(small, 'height')}px;
  margin-top: ${({ small }) => `${small ? '-60px' : '0'}`};
  max-width: 100%;
  overflow: hidden;
`;

const Content = styled.div`
  width: ${({ small }) => getImage(small, 'width')}px;
  height: ${({ small }) => getImage(small, 'height')}px;
  max-width: 100%;

  ${mediaPhone} {
    max-width: ${({ small }) => Math.round(getImage(small, 'width') * getImage(small, 'phoneScale'))}px;
    min-width: 100%;
  }

  margin-left: auto;
  margin-right: auto;

  background-position: ${({ left }) => (left ? 'left' : 'center center')};
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${({ small }) => getImage(small, '1x')});

  @media only screen and (-webkit-min-device-pixel-ratio: 1.5),
         only screen and (min-resolution: 144dpi),
  {
    background-image: url(${({ small }) => getImage(small, '2x')});
  }
`;

const Stacheldraht = ({ left, small, className }) => (
  <Container small={small} className={className}>
    <Content small={small} left={left} />
  </Container>
);

Stacheldraht.propTypes = {
  left: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string,
};

Stacheldraht.defaultProps = {
  left: false,
  small: false,
  className: undefined,
};

export default Stacheldraht;



// WEBPACK FOOTER //
// ./src/components/Stacheldraht/Stacheldraht.js